// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610060617/js/" + chunkId + "." + {"44":"633ba9e7","225":"9002207f","481":"6a97f0b8","486":"d88b088a","770":"7fdbd996"}[chunkId] + ".0.5646257641129425.chunk.js";
};